import { enUS } from "date-fns/locale"
import React, { useEffect, useRef, useState } from "react"
import { DateRange } from "react-date-range"
import calendarIcon from "assets/images/icons/calendar.svg"
import closeIcon from "assets/images/close.png"
import { dateTimeFormat } from "utils/dateFormatUtils"
import moment from "moment"
import { Spinner } from "reactstrap"
import UnitSkeleton from "components/Skeleton/UnitSkeleton"

const DateRangePicker = ({
   range = [
      {
         startDate: undefined,
         endDate: undefined,
         key: "selection",
      },
   ],
   onChange,
   disabled = false,
   onClear = () => {},
   showClearIcon = false,
   hasUserSelectedDate = false,
   isLoading = false,
   minDate,
   maxDate,
}) => {
   const [isOpen, setIsOpen] = useState(false)
   const wrapperRef = useRef(null)
   const isDateSelected = !!range?.[0]?.startDate || !!range?.[0]?.endDate

   // Close on outside click
   useEffect(() => {
      const handleClickOutside = event => {
         if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsOpen(false)
         }
      }

      document.addEventListener("mousedown", handleClickOutside)
      return () => {
         document.removeEventListener("mousedown", handleClickOutside)
      }
   }, [])

   const formatDateRange = range => {
      if (!range?.[0]) return ""

      const startDate = range[0]?.startDate
         ? moment(range[0].startDate).format(dateTimeFormat.americanFormat)
         : ""
      const endDate = range[0]?.endDate
         ? moment(range[0].endDate).format(dateTimeFormat.americanFormat)
         : ""

      return startDate && endDate
         ? `${startDate} - ${endDate}`
         : startDate || endDate || "Select Date Range"
   }

   return (
      <div className="date-range-wrapper align-items-center" ref={wrapperRef}>
         <div
            className={`input-container ${
               disabled ? "input-container-disabled" : "input-container-enabled"
            }`}
         >
            <input
               type="text"
               readOnly
               placeholder={isLoading ? "Loading" : "Select Date Range"}
               value={
                  isLoading
                     ? "Select Date Range"
                     : hasUserSelectedDate
                     ? formatDateRange(range)
                     : ""
               }
               className="input-field"
               onClick={() => !disabled && setIsOpen(!isOpen)}
               disabled={disabled}
               loading={isLoading}
            />
            <div className="input-icon-wrapper">
               {isLoading ? (
                  <Spinner className="input-icon" color="primary" />
               ) : (
                  <>
                     {showClearIcon &&
                        isDateSelected &&
                        hasUserSelectedDate && (
                           <img
                              src={closeIcon}
                              alt="Clear Date"
                              className="input-close-icon"
                              onClick={() => !disabled && onClear(setIsOpen)}
                           />
                        )}
                     <img
                        src={calendarIcon}
                        alt="Calendar Icon"
                        className="input-icon"
                        onClick={() => !disabled && setIsOpen(!isOpen)}
                     />
                  </>
               )}
            </div>
         </div>

         {isOpen && (
            <DateRange
               ranges={range}
               onChange={onChange}
               rangeColors={isDateSelected ? ["#0060bd"] : ["#ffffff"]}
               months={2}
               showSelectionPreview={true}
               locale={enUS}
               minDate={minDate}
               maxDate={maxDate}
               showDateDisplay={false}
               showMonthArrow={true}
               direction="horizontal"
               showMonthAndYearPickers={true}
               className="date-range-picker"
            />
         )}
      </div>
   )
}

export default DateRangePicker
